module.exports = __webpack_public_path__ + "img/yayun.024f06ef.jpg";